<template>
  <div id="forgot_password_form">
    <h3 class="mb-4">
      Forgot your Password ?
    </h3>
    <form class="kt-form" @submit.prevent="submitForgotPassword()">
      <input type="hidden" name="_token" :value="csrf">
      <div v-if="error">
        <div class="alert alert-danger" role="alert">
          {{ error }}
        </div>
      </div>

      <div v-if="success">
        <div class="alert alert-success" role="alert">
          {{ success }}
        </div>
      </div>

      <div class="form-group">
        <input id="email" v-model="form.email"
               type="email"
               class="form-control"
               name="email" required
               placeholder="Email Address..."
               autocomplete="email" autofocus>
      </div>

      <div class="form-group mb-0">
        <button class="btn btn-ss" @click="showForm('login_form')">
          Back
        </button>
        <button id="submit_forgot_password" type="submit" class="btn btn-ss-standout">
          Submit
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import AuthFormsMixin from "VueMixins/AuthFormsMixin";
export default {
  mixins: [AuthFormsMixin],
  data() {
    return {
      form: {
        email: null,
      },
    };
  },
  methods: {
    submitForgotPassword() {
      this.form._token = window.csrfToken;
      this.laddaButton("submit_forgot_password");
      axios.post(`/password/email`, this.form).then(() => {
        this.setSuccess("Password Reset Email has been sent");
        this.unLaddaButton("submit_forgot_password");
      }).catch((err) => {
        this.setError("Something went wrong. Please contact SharpStream Support");
        this.unLaddaButton("submit_forgot_password");
        window.handleAxiosError(err);
      });
    },
  },
};
</script>
